import WebFont from 'webfontloader';

export default function load() {
  WebFont.load({
    google: {
      families: ['Source Sans Pro:400,600,700,900&display=swap'],
    },
  });
}
